<template>
  <div
    @click.stop="$emit('selectEvent', event)"
    :class="['event-container', event.style ? event.style : '']"
    :style="eventStyles()"
    :title="event.name"
  >
    {{ event.type == 5 ? "🔔" : "" }}{{ event.name }}
    <div class="wg-row" style="justify-content: flex-end">
      <template
        v-for="(obj, index) in invitesWithUser.filter(
          (obj) =>
            (obj.user && obj.invite.status == 0) ||
            obj.invite.status == 1 ||
            obj.invite.status == 3,
        )"
      >
        <div
          class="anm22-calendar-icon-inline anm22-calendar-round event-img"
          :key="event.idWorldInvite + '-invite-' + index"
        >
          <world-object-icon
            :type="'user'"
            :obj="obj.user"
            :isImg="true"
          ></world-object-icon>
        </div>
      </template>
      <!-- <img
        v-for="(obj,index) in invitesWithUser.filter(obj => obj.invite.status == 0 || obj.invite.status == 1 || obj.invite.status == 3 )"
        :key="event.idWorldInvite+'-invite-'+index"
        :src="$anm22.getObjIcon(obj.user, 'userDefault')"
        class="anm22-calendar-icon-inline anm22-calendar-round event-img"
        :title="obj.user.name + ' ' + obj.user.surname"
      /> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    eventId: [Number, String],
    styleView: {
      //month, week, list
      type: String,
      default: "month",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
    }),
    event() {
      return this.$store.getters["events/get"](this.eventId);
    },
    invitesWithUser() {
      return this.$store.getters["invites/getByEvent"](
        this.event.idWorldEvent,
      ).map((i) => {
        return {
          invite: i,
          user: this.$store.getters["users/get"](i.user),
        };
      });
    },
  },
  methods: {
    eventStyles() {
      const styles = {
        "font-weight": this.event.labelFontWeight || "",
      };
      if (this.event.style == "outlined") {
        styles.color = this.event.color || "";
        styles.background = "#ffffff";
        styles["border-color"] = this.event.color || "";
      } else if (this.event.style == "filled") {
        if (!this.event.color || this.event.color == "#eeeeee") {
          styles.color = "#222222";
        } else {
          styles.color = "#ffffff";
        }
        styles.background = this.event.color || "";
      }
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-container {
  padding: 2px;
  margin: 2px;
  width: 100%;
  background-color: #eeeeee;
  color: #222222;
  border-radius: 6px;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  min-height: 19px;
  height: 19px;
  &.outlined {
    border: 1px solid #ccc;
  }
  &:hover {
    border-radius: 6px;
    height: 100%;
  }
}
.event-img {
  margin: 2px 5px 0 0;
  width: 22px;
  height: 22px;
}
@media (max-width: 767px) {
  .event-container {
    height: 19px;
  }
  .event-container:hover {
    height: 40px;
  }
}
</style>
